module.exports = __webpack_public_path__ + "img/cn-pro-2.c2e2463e.png";